import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./NavbarMain.css";
import { RiArrowDropDownFill } from "react-icons/ri";
import EnquiryPopup from "../Common/EnquiryPopup";
import { FaBars, FaTimes } from "react-icons/fa";

const NavbarMain = () => {
const [menuOpen, setMenuOpen] = useState(false);
const [showEnquiry, setShowEnquiry] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

    useEffect(() => {
    const addGoogleTranslateScript = () => {
      if (!document.getElementById("google-translate-script")) {
        const script = document.createElement("script");
        script.id = "google-translate-script";
        script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.body.appendChild(script);

        window.googleTranslateElementInit = () => {
          new window.google.translate.TranslateElement(
            { pageLanguage: "en", layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE },
            "google_translate_element"
          );
        };
      }
    };

    addGoogleTranslateScript();
  }, []);


  return (
    <header className="bb-header">

      {/* MAIN NAVBAR */}
      <div className="bb-nav">
        {/* <Container fluid className="bb-nav-inner"> */}

          {/* LOGO */}
          <div className="bb-logo-wrap slanted-div">
            <Link to="/">
              <img src="/Images/tour/logo.png" alt="Logo" />
            </Link>

            {/* ONLY ONE TOGGLE */}
            <div
              className="bb-mobile-toggle"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? <FaTimes /> : <FaBars />}
            </div>
          </div>

          {/* MENU */}
          <div className="bb-topbar-rightMenu">
          {/* TOP BLUE STRIP */}
          <div className="bb-topbar">
          {/* <Container fluid className="bb-topbar-inner"> */}
            <div className="bb-topbar-left">
              24 Hrs Emergency: +91-9560321110 &nbsp; | &nbsp; Sales & Info.: +91-9555432221
              &nbsp; | &nbsp; B2B Marketing: 011-27353427
              {/* <a href="mailto:help@bharatbooking.com">
                help@bharatbooking.com
              </a> */}
            </div>

            <div className="bb-topbar-right" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button className="bb-quote" onClick={() => setShowEnquiry(true)}>
                Get a free Quote
              </button>
              <div id="google_translate_element"></div>
            </div>

            {/* </Container> */}
          </div>

      {menuOpen && <div className="bb-overlay" onClick={closeMenu}></div>}

      <ul className={`bb-menu ${menuOpen ? "open" : ""}`}>

        {/* HOME */}
        <li>
          <Link to="/" onClick={closeMenu}>
            <img src="/Images/tour/Icons/home.png" alt="" />
            <span>Home</span>
          </Link>
        </li>

        {/* INDIA PACKAGES */}
        <li className="has-dropdown">
          <Link to="/india-holiday-packages" onClick={closeMenu}>
            <img src="/Images/tour/Icons/india.png" alt="" />
            <span>India Holidays</span>
          </Link>

          {/* <ul className="bb-dropdown">
            <li><Link to="/lakshadweep">Lakshadweep</Link></li>
            <li><Link to="/kerala">Kerala</Link></li>
            <li><Link to="/uttarakhand">Uttarakhand</Link></li>
            <li><Link to="/kashmir">Kashmir</Link></li>
            <li><Link to="/northeast">North East</Link></li>
            <li><Link to="/himachal-pradesh">Himachal Pradesh</Link></li>
            <li><Link to="/goa">Goa</Link></li>
            <li><Link to="/ladakh">Ladakh</Link></li>
          </ul> */}
        </li>

        {/* INTERNATIONAL PACKAGES */}
        <li className="has-dropdown">
          <Link to="/international-tour-packages" onClick={closeMenu}>
            <img src="/Images/tour/Icons/international.png" alt="" />
            <span>International Holidays</span>
          </Link>

          {/* <ul className="bb-dropdown">
            <li><Link to="/europe">Europe</Link></li>
            <li><Link to="/austria">Austria</Link></li>
            <li><Link to="/japan">Japan</Link></li>
            <li><Link to="/russia">Russia</Link></li>
            <li><Link to="/bali">Bali</Link></li>
            <li><Link to="/mauritius">Mauritius</Link></li>
            <li><Link to="/malaysia">Malaysia</Link></li>
            <li><Link to="/france">France</Link></li>
            <li><Link to="/switzerland">Switzerland</Link></li>
            <li><Link to="/africa">Africa</Link></li>
            <li><Link to="/spain">Spain</Link></li>
            <li><Link to="/italy">Italy</Link></li>
            
          </ul> */}
        </li>

        {/* MICE */}
        <li>
          <Link to="/mice-corporate-travel" onClick={closeMenu}>
            <img src="/Images/tour/Icons/miee.png" alt="" />
            <span>MICE & Corporate Travel</span>
          </Link>
        </li>

        {/* About Us */}
        <li>
          <Link to="/about-plenary-holidays" onClick={closeMenu}>
            <img src="/Images/tour/Icons/group.png" alt="" />
            <span>About Us</span>
          </Link>
        </li>

        {/* Blogs */}
          <li>
          <Link to="/blog" onClick={closeMenu}>
            <img src="/Images/tour/Icons/blog.png" alt="" />
            <span>Blogs</span>
          </Link>
        </li>

        {/* Gallery */}
        <li>
          <Link to="/" onClick={closeMenu}>
            <img src="/Images/tour/Icons/gallery.png" alt="" />
            <span>Gallery</span>
          </Link>
        </li>
        
        {/* Certificates */}
        <li>
          <Link to="/plenaryholidays-certificates" onClick={closeMenu}>
            <img src="/Images/tour/Icons/certificate.png" alt="" />
            <span>Certificates</span>
          </Link>
        </li>

        {/* CONTACT */}
        <li>
          <Link to="/contact" onClick={closeMenu}>
            <img src="/Images/tour/Icons/phone.png" alt="" />
            <span>Contact Us</span>
          </Link>
        </li>

      </ul>

         </div>
        {/* </Container> */}
      </div>
              <EnquiryPopup
              destination=""  
              open={showEnquiry}
              onClose={() => setShowEnquiry(false)}
            />

    </header>
  );
};

export default NavbarMain;
